import React from 'react';
import AuthService from './authService.js';

class CompanyService extends React.Component {
    static GetCompanyList(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
        return AuthService.getInstance()
            .CallBackendFunction(
                "/api/Company/GetCompanies?"
                + "orderBy=" + orderById
                + "&orderDirection=" + orderDir
                + "&pageNumber=" + pageNumber
                + "&numberOfElements=" + numberOfElements
                + "&searchItem=" + JSON.stringify(encodeURIComponent(searchItem))
            );
    }

    static GetCompanyByName(companyName) {
        return AuthService.getInstance()
            .CallBackendFunction(
                "/api/Company/GetCompanyMatch?"
                + "&companyName=" + JSON.stringify(encodeURIComponent(companyName))
            );
    }

    static GetMultipleCompanyMatches(companyName) {
        return AuthService.getInstance()
            .CallBackendFunction(
                "/api/Company/GetMultipleCompanyMatches?"
                + "&companyName=" + JSON.stringify(encodeURIComponent(companyName))
            );
    }

    static GetMultipleClientCompanyMatches(companyName) {
        return AuthService.getInstance()
            .CallBackendFunction(
                "/api/Company/GetMultipleClientCompanyMatches?"
                + "&companyName=" + JSON.stringify(encodeURIComponent(companyName))
            );
    }
}

export default CompanyService;